// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"90d848c8","339":"1da8194e","388":"e516ce19","484":"381d5b0a","488":"546e5a13","498":"d46aba58","551":"5c188c3d","617":"594cfc5d","828":"e1ed309e"}[chunkId] + ".chunk.js";
};